import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';
import { LayoutConfig } from '@spartacus/storefront';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      layoutSlots: {
        header: null,
        ContentPage1Template: null,
        ErrorPageTemplate: null,
        LandingPage2Template: null,
        ProductListPageTemplate: null,
        ProductDetailsPageTemplate: null,
        CartPageTemplate: null,
        SearchResultsEmptyPageTemplate: null,
        ShimanoArticlePageTemplate: null,
        MyAccountPageTemplate: null,
        NewsPageTemplate: null,
        DownloadsPageTemplate: null,
        ShimanoCustomerServicePageTemplate: null,
        ShimanoCheckoutSummaryPageTemplate: null,
        OrderConfirmationPageTemplate: null,
        OrderHistoryPageTemplate: null,
        footer: null,
        LoginPageTemplate: null,
        QuickOrderPageTemplate: null,
        ImportCartTemplate: null,
        AccountPageTemplate: null,
        OrderDetailsPageTemplate: null,
        SavedCartDetailsPageTemplate: null,
        ShimanoOrderFormPageTemplate: null,
        DealerSelectionPageTemplate: null,
        UnitSelectionPageTemplate: null,
        MyAccountDiscountsPageTemplate: null,
        CookiesPageTemplate: null,
        SearchResultsListPageTemplate: null,
        ExplodedViewPageTemplate: null,
        SimpleLandingPageTemplate: null,
      },
    } as LayoutConfig),

    ConfigModule.withConfig({
      breakpoints: {
        xs: 320,
        sm: 577,
        md: 768,
        lg: 1025,
        xl: 1440,
      },
      layoutSlots: {
        header: {
          xl: {
            slots: [
              'SalesRepInfoBar',
              'HeaderLinks',
              'SiteLogo',
              'SearchBox',
              'SrpToggle',
              'MiniCart',
              'MyAccount',
              'SiteContext',
              'NavigationBar',
            ],
          },
          lg: {
            slots: ['SalesRepInfoBar', 'SiteLogo', 'SearchBox', 'SrpToggle', 'MiniCart', 'MyAccount', 'NavigationBar'],
          },
          xs: {
            slots: ['SalesRepInfoBar', 'SiteLogo', 'SearchBox', 'SrpToggle', 'MiniCart', 'MyAccount', 'NavigationBar'],
          },
        },
        ContentPage1Template: {
          slots: ['Section1', 'Section2', 'Section3', 'Section4', 'Section5'],
        },
        ErrorPageTemplate: {
          slots: ['BackgroundContent', 'TopContent', 'MiddleContent', 'BottomContent'],
        },
        LandingPage2Template: {
          slots: ['Section1', 'Section2', 'Section3', 'Section4', 'Section5'],
        },
        DownloadsPageTemplate: {
          slots: ['SideContent', 'BodyContent'],
        },
        ProductListPageTemplate: {
          slots: ['ProductLeftRefinements', 'ProductListSlot'],
        },
        ProductDetailsPageTemplate: {
          md: {
            pageFold: 'UpSelling',
          },
          xs: {
            pageFold: 'Summary',
          },
          slots: ['Summary', 'ProductDescription', 'AdditionalDetails'],
        },
        CartPageTemplate: {
          slots: [
            'EmptyCartMiddleContent',
            'TopContent',
            'CenterLeftContentSlot',
            'CenterRightContentSlot',
            'BottomContentSlot',
            'EmptyCartBottomContent',
          ],
        },
        footer: {
          slots: ['Footer'],
        },
        MyAccountPageTemplate: {
          slots: [
            'CompanyContent',
            'AccountInfo',
            'YourCredentials',
            'EmployeeManagement',
            'ChangePassword',
            'EditPersonalInfo',
            'EditPreferences',
            'AddEmployee',
            'EditEmployee',
          ],
        },
        NewsPageTemplate: {
          slots: ['SideContent', 'BodyContent'],
        },
        OrderDetailsPageTemplate: {
          slots: ['SideContent', 'BodyContent'],
        },
        SearchResultsEmptyPageTemplate: {
          slots: ['TopContent', 'SideContent', 'MiddleContent', 'BottomContent'],
        },
        ShimanoArticlePageTemplate: {
          slots: ['ArticleSection', 'RelatedArticlesSection'],
        },
        ShimanoCustomerServicePageTemplate: {
          slots: ['CustomerServiceBanner', 'CustomerServiceContent'],
        },
        LoginPageTemplate: {
          slots: ['LeftContentSlot', 'RightContentSlot'],
        },
        ShimanoCheckoutSummaryPageTemplate: {
          slots: ['BodyContent', 'SideContent'],
        },
        OrderHistoryPageTemplate: {
          slots: ['SideContent', 'BodyContent'],
        },
        OrderConfirmationPageTemplate: {
          slots: ['BodyContent'],
        },
        ImportCartTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        QuickOrderPageTemplate: {
          slots: ['TopContent', 'QuickOrderFormSection'],
        },
        AccountPageTemplate: {
          slots: ['BodyContent', 'SideContent'],
        },
        SavedCartDetailsPageTemplate: {
          slots: ['BodyContent', 'SideContent'],
        },
        ShimanoOrderFormPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        DealerSelectionPageTemplate: {
          slots: ['BodyContent'],
        },
        MyAccountDiscountsPageTemplate: {
          slots: ['TopContent', 'LeftContent', 'BodyContent'],
        },
        CookiesPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        SearchResultsListPageTemplate: {
          slots: ['ProductLeftRefinements', 'SearchResultsListSlot'],
        },
        ExplodedViewPageTemplate: {
          slots: ['BodyContent'],
        },
        GlobalRedirectionLoginPageTemplate: {
          slots: ['LeftContentSlot', 'RightContentSlot'],
        },
        UnitSelectionPageTemplate: {
          slots: ['BodyContent'],
        },
        SimpleLandingPageTemplate: {
          slots: ['BodyContent'],
        },
      },
    } as LayoutConfig),
  ],
})
export class LayoutConfigModule {}
